import { Component, OnInit, ViewChildren, QueryList  } from '@angular/core';
import { ActivatedRoute, Router, ParamMap } from '@angular/router';

import { AuthenticationService } from "../../../services/authentication/authentication.service";
import { Message } from 'primeng/components/common/api';
import {ResetPasswordModel } from "../../../models/inModels/ChangePasswordModel";
import {ShowHideInput} from "../../../directives/show-hide.directive";

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.css']
})
export class ResetPasswordComponent implements OnInit {
    model: ResetPasswordModel;
    otp: boolean;
	show = false;
	showLogin = false;
	loading = false;
    messages: Message[];
	@ViewChildren(ShowHideInput) input: QueryList<ShowHideInput>;
	
	constructor(
		private route: ActivatedRoute,
		private router: Router,
		private authenticationService: AuthenticationService) { }

	ngOnInit() {
		this.model = new ResetPasswordModel;
		this.model.UserId = this.route.snapshot.paramMap.get('UserId');

		const code = this.route.snapshot.queryParamMap.get('token');
		const otp = this.route.snapshot.queryParamMap.get('otp');
		this.model.Code = code || otp;

		this.otp = otp != null;
	}

	post(): void {
		this.loading = true;
		if (this.otp) {
			this.authenticationService.resetPasswordOtp(this.model).then(
				result => {
                    this.loading = false;
					this.showLogin = true;
					this.messages = [];
					this.messages.push({
						severity: 'success',
						summary: 'Success',
						detail: 'Password Reset Successesfully.'
					});
				},
				error => {
					this.loading = false;
					this.messages = [];
					this.messages.push({ severity: 'error', summary: 'Error', detail: error });
				}
			);
		} else {
			this.authenticationService.resetPassword(this.model).then(
				result => {
                    this.loading = false;
					this.showLogin = true;
					this.messages = [];
					this.messages.push({
						severity: 'success',
						summary: 'Success',
						detail: 'Password Reset Successesfully.'
					});
				},
				error => {
					this.loading = false;
					this.messages = [];
					this.messages.push({ severity: 'error', summary: 'Error', detail: error });
				}
			);
		}

    }
	showPassword(event: any): void {
		this.show = true;
		this.changeType();
	}

	hidePassword(event: any): void {
		this.show = false;
		this.changeType();
	}

	changeType(): void {
		if (this.show) {
			this.input.first.changeType("text");
			this.input.last.changeType("text");
		}
		else {
			this.input.first.changeType("password");
			this.input.last.changeType("password");
		}
	}
}



// WEBPACK FOOTER //
// ./src/app/components/manage/reset-password/reset-password.component.ts